import { ReactComponent as ScuoreCardIcon } from '../../assets/img/scuore-card.svg';

/**
 * Icon component with support for different variants
 * @param {string} size - Size of the icon (default: '24px')
 * @param {string} variant - Icon variant: 'card'
 * @param {object} sx - MUI sx prop for additional styling
 * @param {string} className - CSS class name
 */
const Icon = ({
  size = '24px',
  variant = 'card',
  sx = {},
  className = '',
  ...props
}) => {
  const getIconComponent = () => {
    switch (variant) {
      case 'card':
        return ScuoreCardIcon;
      default:
        return ScuoreCardIcon;
    }
  };

  const IconComponent = getIconComponent();

  return (
    <IconComponent
      width={size}
      height={size}
      className={className}
      style={{
        display: 'block',
        maxWidth: '100%',
        maxHeight: '100%',
        ...sx,
      }}
      {...props}
    />
  );
};

export default Icon;
